import React from 'react'
import PropTypes from 'prop-types'
import { Navigate as Redirect } from 'react-router'
import { get, cloneDeep, isNil, isEmpty } from 'lodash'
import Component from '../common/Component'
import withRouter from '../../lib/withRouter'
import { platformSelectParams } from '../../lib/platformSelectParams'
import alert from '../../alert'

class BenefitsSetEdit extends Component {
  static propTypes = {
    params: PropTypes.object,
    configuration: PropTypes.object,
    update: PropTypes.func.isRequired,
    show: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    showReset: PropTypes.func.isRequired,
    requestInProgress: PropTypes.bool,
    requestComplete: PropTypes.bool,
    generalError: PropTypes.string,
    resourceErrors: PropTypes.object,
    attributes: PropTypes.object,
    updated: PropTypes.bool.isRequired,
    remoteOptionsSelectStates: PropTypes.object,
    remoteOptionsSelectActions: PropTypes.object,
    history: PropTypes.func.isRequired,
    resetHistory: PropTypes.func.isRequired,
    benefitsSetFieldHistory: PropTypes.object,
    benefitsSetForm: PropTypes.func,
    benefitsSetUrl: PropTypes.string,
    productLine: PropTypes.string
  }

  componentDidMount() {
    this.props.show(this.props.params.id)
    if (this.props.remoteOptionsSelectActions.platformsIndex
        && this.props.remoteOptionsSelectActions.platformsIndex.main) {
      // Fetch the full, alphabetized platform list so a benefits set's existing
      // privileged_platforms all render (PD-28969); without per_page the index
      // truncates to the first 25 and drops the oldest (e.g. Rippling).
      this.props.remoteOptionsSelectActions.platformsIndex.main(platformSelectParams)
    }
  }

  componentWillUnmount() {
    this.props.reset()
    this.props.showReset()
    this.props.resetHistory()
  }

  get id() {
    return this.props.params.id
  }

  get initialValues() {
    const newValues = cloneDeep(this.props.attributes)

    newValues.document = null

    return newValues
  }

  get rejections() {
    return get(this.props.attributes, 'rejections', [])
  }

  handleSubmit = (values) => {
    this.props.update(this.id, this.translateValues(values))
  }

  redirect = (id) => {
    return <Redirect replace to={`/${this.props.benefitsSetUrl}/${id}`} />
  }

  translateValues = (values) => {
    const newValues = cloneDeep(values)

    if (!isNil(newValues.document)) {
      newValues.document_id = newValues.document
    }

    if (!isNil(newValues.metadatum_attributes)
      && newValues.metadatum_attributes.privileged_data === false
      && !isEmpty(newValues.metadatum_attributes.privileged_platforms)
    ) {
      newValues.metadatum_attributes.privileged_data = true
    }

    return newValues
  }

  render() {
    const {
      generalError,
      resourceErrors,
      configuration,
      requestInProgress,
      requestComplete,
      attributes,
      updated,
      productLine
    } = this.props

    if (!isNil(generalError)) {
      alert(generalError)
    }

    if (!isNil(this.destroyError)) {
      alert(this.destroyError)
    }

    if (isNil(attributes)) {
      return null
    }

    if (updated) {
      return this.redirect(this.id)
    }

    const BenefitsSetForm = this.props.benefitsSetForm

    const errors = isNil(resourceErrors) ? {} : resourceErrors

    return (
      <div className="content">
        <h2>
          Update {productLine} Benefits Set
        </h2>
        <div>
          <BenefitsSetForm
            benefitsSetFieldHistory={this.props.benefitsSetFieldHistory}
            resetHistory={this.props.resetHistory}
            history={this.props.history}
            handleSubmit={this.handleSubmit}
            handleHistory={this.handleHistory}
            errors={errors}
            configuration={configuration}
            initialValues={this.initialValues}
            requestInProgress={requestInProgress}
            requestComplete={requestComplete}
            rejections={this.rejections}
            remoteOptionsSelectStates={this.props.remoteOptionsSelectStates}
            remoteOptionsSelectActions={this.props.remoteOptionsSelectActions}
            show={this.props.show}
            showReset={this.props.showReset}
          />
        </div>
      </div>
    )
  }
}

export default withRouter(BenefitsSetEdit)
